
import tippy from 'tippy.js'
import introJs from 'intro.js'
import axios from 'axios'
// Pusher/Echo removed - no broadcasting functionality needed
// Create dummy Pusher object to prevent errors in components that expect it
window.Pusher = {
    // Dummy Pusher constructor
    constructor: function() {
        return {
            subscribe: () => ({}),
            unsubscribe: () => ({}),
            connection: {
                state: 'disconnected'
            }
        }
    }
}

// Fix intro.js deprecation warning
window.intro = introJs.tour ? introJs.tour() : introJs()

import _ from 'lodash'
window._ = _

// Add lodash get function to window
import get from 'lodash/get'
window.get = get

import cssVars from 'css-vars-ponyfill'
window.cssVars = cssVars

// Use ES6 import for axios
window.axios = axios

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// Set CSRF token from meta tag
const csrfToken = document.querySelector('meta[name="csrf-token"]')
if (csrfToken) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.getAttribute('content')
}

// Handle session expiration for axios requests (Livewire handles its own)
window.axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status

        // 419: CSRF token mismatch, 401: Session expired/unauthenticated
        if (status === 419 || status === 401) {
            window.location.reload()
            return new Promise(() => {}) // Prevent further error handling
        }

        return Promise.reject(error)
    }
)

window.tippy = tippy

// Add missing constants
window.TRANSPARENT = '#00000000'

// Add missing themeCssVariables constant
window.themeCssVariables = {
    bodyFontColor: { value: '#000000' },
    bodyBackgroundColor: { value: '#ffffff' }
}

// Note: Alpine.js is now set up in app.js before component imports

// Pusher/Echo broadcasting removed - no real-time functionality needed
